import { useMutation } from "@tanstack/react-query";
import { request } from "../../../services/axios.service";
import { apiUrls } from "../../api-urls";

const update = async (data: { _id: string; status: boolean }) => {
  const response: TServerResponse = await request({
    url: apiUrls.blogs.UPDATE_BLOGS_STATUS,
    method: "POST",
    data,
  });
  return response;
};

export const useUpdateBlogsStatusMutation = () => {
  return useMutation({ mutationFn: update });
};
